import {
  Box,
  styled,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { format } from "date-fns";

import { Typography } from "components/Typography";
import { STATUS_TYPES } from "pages/Dashboard/components/DashboardChart/components/StatusFilter";
import bannerImage from "assets/Receipt banner cover.png";

const Container = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
}));

export const ReceiptTemplate = ({ data, totalAmount, isCredit }) => {
  if (!data) return null;

  const statusColor =
    data.status === STATUS_TYPES.FAILED
      ? "#E60412"
      : data.status === STATUS_TYPES.PENDING
      ? "#FF9900"
      : "#019B36";

  const formatName = (name = "") =>
    name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <Container>
      <Box
        sx={{
          width: "600px",
          marginTop: "20px",
        }}
      >
        <Box sx={{ margin: "40px", textAlign: "center", color: "#0E60E2" }}>
          <Typography variant="loginHeading" component="h2">
            Cowry
          </Typography>
        </Box>
        <Box sx={{ marginBottom: "40px" }}>
          <img
            src={bannerImage}
            alt="Receipt Banner"
            style={{
              width: "100%",
              borderRadius: "12px 12px 0 0",
              objectFit: "cover",
            }}
          />
        </Box>
        <Typography variant="emailSubHeadline" gutterBottom>
          <strong>Hi {formatName(data?.accountName)} </strong>👋🏾,
        </Typography>
        <Box></Box>
        <Typography sx={{ margin: "30px 0" }}>
          We&apos;re confirming that we have processed your transfer and it
          should arrive within 24 hours. Please quote this transaction reference
          when you contact us <strong>{data.transIdRef}</strong>
        </Typography>

        <Typography
          align="center"
          sx={{
            color: isCredit ? "#019B36" : "#E60412",
            margin: "20px 0",
          }}
        >
          {isCredit ? "Credit Amount" : "Debit Amount"} <br />
        </Typography>
        <Typography
          align="center"
          variant="loginHeading"
          sx={{ display: "block" }}
        >
          {totalAmount}
        </Typography>

        <Typography variant="emailSubHeadline">Transaction Details</Typography>

        <Box sx={{ mt: 2, backgroundColor: "#FAFAFBB8", borderRadius: 1 }}>
          <Table
            sx={{
              width: "100%",
              borderCollapse: "collapse",
              "& td": { borderBottom: "none", py: 1 },
            }}
          >
            <TableBody>
              <TableRow>
                <TableCell>Transaction ref</TableCell>
                <TableCell>{data.transIdRef}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Transaction status</TableCell>
                <TableCell sx={{ color: statusColor }}>
                  {data.status === STATUS_TYPES.FAILED
                    ? "Failed"
                    : data.status === STATUS_TYPES.PENDING
                    ? "Pending"
                    : "Successful"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Payment type</TableCell>
                <TableCell>{data.paymentMode}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Account number</TableCell>
                <TableCell>{data.accountNo}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Amount</TableCell>
                <TableCell>{totalAmount}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>
                  {data.createdOn
                    ? format(new Date(data.createdOn * 1000), "dd/MM/yyyy")
                    : "—"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Remark</TableCell>
                <TableCell>{data.reason}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Container>
  );
};
